import { Link, UIMatch, useLocation, useMatches, useNavigate } from "react-router";
import React from "react";


type CrumbReturnType = React.ReactNode | string;

interface BreadcrumbsProps {
    showBackButtonRoutes?: string[]; // Array of routes where back button should be shown
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ showBackButtonRoutes = [] }) => {
    const matches = useMatches();
    const location = useLocation();
    const navigate = useNavigate();

    const categoryCrumbs = React.useMemo(
        () => matches.reduce((acc, match: UIMatch<any, any>) => {
            if (typeof match.handle?.crumb === 'function') {
                const crumb = match.handle.crumb(match);
                acc.push(...Array.isArray(crumb) ? crumb : [crumb]);
            }
            return acc;
        }, [] as CrumbReturnType[]),
        [matches],
    );

    const extraBreadcrumbItems = React.useMemo(
        () =>
            categoryCrumbs.map((crumb, index) => ({
                key: `crumb-${index}`,
                title: crumb,
            })),
        [categoryCrumbs],
    );

    const breadcrumbItems = React.useMemo(
        () => [
            {
                key: 'home',
                title: (
                    <Link to='/'>
                        Home
                    </Link>
                ),
            },
            ...extraBreadcrumbItems,
        ],
        [extraBreadcrumbItems],
    );

    const shouldShowBackButton = React.useMemo(() => {
        if (!showBackButtonRoutes.length) return false; // Show by default if no routes specified
        return showBackButtonRoutes.some(route => location.pathname.startsWith(route));
    }, [showBackButtonRoutes, location.pathname]);

    if (location.pathname === '/') {
        return null;
    }

    return <div className="breadcrumbs">
        <div className="breadcrumbs__inner inside-wrapper">
            <ul className="breadcrumbs__list">
                {breadcrumbItems.map((item, index) => (
                    <li className="breadcrumbs__item" key={`breadcrumb-${index}`}>
                        {React.isValidElement(item.title) ? item.title : <span className="breadcrumbs__text">{item.title}</span>}
                    </li>
                ))}
            </ul>
            {shouldShowBackButton && (
                <div className="breadcrumbs__btns">
                    <a href="#" onClick={(ev) => {
                        ev.preventDefault();
                        navigate(-1);
                    }} className="btn btn_cta">&lt; Back</a>
                </div>
            )}
        </div>
    </div>
};